import { render, staticRenderFns } from "./KeluhanCard.vue?vue&type=template&id=5bce4428&"
import script from "./KeluhanCard.vue?vue&type=script&lang=js&"
export * from "./KeluhanCard.vue?vue&type=script&lang=js&"
import style0 from "./KeluhanCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports